import type { DocumentDownloadSecretPayload } from './DocumentDownloadSecretPayload.type'
import { getPropstackDocumentViewerSecret } from './getPropstackDocumentViewerSecret'

type GetPropstackDocumentViewerUrlOptions = DocumentDownloadSecretPayload & {
  withSecret?: boolean
  absoluteUrl?: boolean
}

export const getPropstackDocumentViewerUrl = ({
  documentId,
  withSecret = false,
  absoluteUrl = false,
}: GetPropstackDocumentViewerUrlOptions) => {
  const baseUrl = absoluteUrl ? process.env.NEXT_PUBLIC_NEXT_BASE_URL : ''
  let url = `${baseUrl}/download/document/${documentId}`

  if (withSecret) {
    const secret = getPropstackDocumentViewerSecret({ documentId })
    url = `${url}?secret=${secret}`
  }

  return url
}
